import { Recurso } from "lib.common/dist/CleanArch";
import { AbonosPasarelaDtSource } from "../../bussines/dataSources/AbonosPasarelaDtSource";
import { Pago, PagoDetalle } from "../../bussines/entities/Pago";
import { AbonosPasarelaRepository } from "../../bussines/repositories/AbonosPasarelaRepository";
import { GetDetallesAbonoParams, GetSomeAbonosPasarelaParams } from "../../utils/params/GetSomeAbonosPasarelaParams";
import { PagoModel } from "../models/PagoModel";
import { ErrDevValidacion } from "lib.common/dist/errorHandler";
import { PagoDetalleModel } from "../models/PagoDetalleModel";

export class AbonosPasarelaRepositoryImpl implements AbonosPasarelaRepository<Pago,PagoDetalle> {
    private dataSource: AbonosPasarelaDtSource;
    constructor(dataSource: AbonosPasarelaDtSource) {
        this.dataSource = dataSource;
    }
    async getSomeAbonosPasarela(input: GetSomeAbonosPasarelaParams): Promise<Recurso<Pago[]>> {
        try {
            const result = await this.dataSource.getSomeAbonosPasarela(input);
            if (result.isSuccess()) {
                return Recurso.fromData<Pago[]>(
                    result.data!.map(PagoModel.deserialize)
                );
            }
            return Recurso.fromError<Pago[]>(result.error!);

        } catch (error) {
            return Recurso.fromError<Pago[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }
    
    async getDetallesAbono(input: GetDetallesAbonoParams): Promise<Recurso<PagoDetalle[]>> {
        try {
            const result = await this.dataSource.getDetallesAbono(input);
            if (result.isSuccess()) {
                return Recurso.fromData<PagoDetalle[]>(
                    result.data!.map(PagoDetalleModel.deserialize)
                );
            }
            return Recurso.fromError<PagoDetalle[]>(result.error!);

        } catch (error) {
            return Recurso.fromError<PagoDetalle[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

}